const agent_data = () => import(/* webpackChunkName: "ehcarts" */ '../agent/data');
const convenientList = () => import(/* webpackChunkName: "ehcarts" */ '../agent/convenientList');
const shopList = () => import(/* webpackChunkName: "ehcarts" */ '../agent/shopList');
const typeList = () => import(/* webpackChunkName: "ehcarts" */ '../agent/typeList');
const cityList = () => import(/* webpackChunkName: "ehcarts" */ '../agent/cityList');
const gxlb = () => import(/* webpackChunkName: "ueditor" */ '../agent/gxlb');
const gxcp = () => import(/* webpackChunkName: "ueditor" */ '../agent/gxcp');
const gxal = () => import(/* webpackChunkName: "ueditor" */ '../agent/gxal');
const agentlogin = () => import(/* webpackChunkName: "agent_login" */ '../agent/login');
const loginUnbound = () => import(/* webpackChunkName: "agent_login" */ '../agent/loginUnbound');
const forgetPassword = () => import(/* webpackChunkName: "agent_login" */ '../agent/forgetPassword');
//整体路由重新进行打包分割

const agent_partner = () => import(/* webpackChunkName: "agent" */ '../components/partner');
const agent_zdlist = () => import(/* webpackChunkName: "agent" */ '../agent/zdlist');
const agent_information = () => import(/* webpackChunkName: "agent" */ '../agent/information');
const agent_zdblack = () => import(/* webpackChunkName: "agent" */ '../agent/zdblack');
const agent_functionlist = () => import(/* webpackChunkName: "agent" */ '../agent/functionlist');
const agent_function = () => import(/* webpackChunkName: "agent" */ '../agent/function');
const agent_audit = () => import(/* webpackChunkName: "agent" */ '../agent/audit');
const agent_data_audit = () => import(/* webpackChunkName: "agent" */ '../agent/data_audit');
const agent_regscene = () => import(/* webpackChunkName: "agent" */ '../regscene/regscene');
const agent_cjlistindex = () => import(/* webpackChunkName: "agent" */ '../agent/cjlistindex');
const agent_menu = () => import(/* webpackChunkName: "agent" */ '../agent/menu');
const agent_travel = () => import(/* webpackChunkName: "agent" */ '../agent/travel');
const agent_baiduMapApply = () => import(/* webpackChunkName: "agent" */ '../agent/baiduMapApply');
const agent_livelist = () => import(/* webpackChunkName: "agent" */ '../agent/livelist');
const agent_livelog = () => import(/* webpackChunkName: "agent" */ '../agent/livelog');
const agent_means = () => import(/* webpackChunkName: "agent" */ '../agent/means');
const agent_gxsz = () => import(/* webpackChunkName: "agent" */ '../agent/gxsz');
const agent_gxgwmb = () => import(/* webpackChunkName: "agent" */ '../agent/gxgwmb');
const agent_gxlygl = () => import(/* webpackChunkName: "agent" */ '../agent/gxlygl');
const agent_gxtw = () => import(/* webpackChunkName: "agent" */ '../agent/gxtw');
const agent_setup = () => import(/* webpackChunkName: "agent" */ '../agent/setup');
const agent_personal = () => import(/* webpackChunkName: "agent" */ '../agent/personal');
const agent_password = () => import(/* webpackChunkName: "agent" */ '../agent/password');
const agent_news = () => import(/* webpackChunkName: "agent" */ '../agent/news');
const agent_week = () => import(/* webpackChunkName: "agent" */ '../agent/week');
const agent_website = () => import(/* webpackChunkName: "agent" */ '../agent/website');
const agent_website1 = () => import(/* webpackChunkName: "agent" */ '../agent/website1');
const agent_web = () => import(/* webpackChunkName: "agent" */ '../agent/web');

// 订单管理
const agent_ordermanage = () => import('../agent/orderManage/index');
const agent_aiDigital = () => import('../agent/orderManage/aiDigital');
const agent_renewalOrder = () => import('../agent/orderManage/renewalOrder');

var agent_router = [
    {
        path: "/agent/login",//登录
        name: "/agentlogin",
        component: agentlogin,
        meta: {title: "合作商登录"},
    },
    {
        path: "/agent/loginUnbound",//未绑定登录
        name: "/loginUnbound",
        component: loginUnbound,
        meta: {title: "未绑定登录"},
    },
    {
        path: "/agent/forgetPassword",//忘记密码
        name: "/forgetPassword",
        component: forgetPassword,
        meta: {title: "忘记密码"},
    },
    {
        path: "/agent",
        name: "/agent",
        component: agent_partner,
        redirect: "/agent/zdlist",
        children: [
            {
                name: "/agent/zdlist",
                path: "/agent/zdlist",
                component: agent_zdlist,
                meta: {title: "终端用户列表"},
            },

            {
                name: "/agent/zdlist/information",
                path: "/agent/zdlist/information",
                component: agent_information,
                meta: {title: "创建用户"},
            },
            {
                name: "/agent/zdlist/zdblack",
                path: "/agent/zdlist/zdblack",
                component: agent_zdblack,
                meta: {title: "黑名单"},
            },
            {
                name: "/agent/zdlist/functionlist",
                path: "/agent/zdlist/functionlist",
                component: agent_functionlist,
                meta: {title: "功能组"},
            },
            {
                name: "/agent/zdlist/function",
                path: "/agent/zdlist/function",
                component: agent_function,
                meta: {title: "添加功能组"},
            }, {
                path: '/agent/zdlist/audit',
                name: '/agent/zdlist/audit',//终端审核√
                component: agent_audit,
                meta: {title: "终端审核"},
            }, {
                name: "/agent/zdlist/data_audit",
                path: "/agent/zdlist/data_audit",//添加用户组√
                component: agent_data_audit,
                meta: {title: "添加用户组"},
            },
        ]
    },
    {
        path: '/agent/regscene/index',
        name: '/agent/regscene/index',//注册中心
        component: agent_partner,
        redirect: '/agent/regscene',
        children: [{
            path: '/agent/regscene',
            name: '/agent/regscene',//注册信息列表√
            component: agent_regscene,
            meta: {title: "注册信息列表"},
        }]
    },
    {
        path: "/agent/cjlist/index",
        name: "/agent/cjlist/index",
        component: agent_partner,
        redirect: "/agent/cjlist",
        children: [
            {
                name: "/agent/cjlist",
                path: "/agent/cjlist",
                component: agent_cjlistindex,
                meta: {title: "作品列表"},
            },
            {
                name: "/agent/travel",
                path: "/agent/travel",
                component: agent_travel,
                meta: {title: "云游列表"},
            },
            {
                name: "/agent/menu",
                path: "/agent/menu",
                component: agent_menu,
                meta: {title: "酷客导航列表"},
            },
            {
                name: "/agent/baiduMapApply",
                path: "/agent/baiduMapApply",
                component: agent_baiduMapApply,
                meta: {title: "百度地图申请表"},
            }
        ]
    },
    {
        path: "/agent/livelist/index",
        name: "/agent/livelist/index",
        component: agent_partner,
        redirect: "/agent/livelist",
        children: [
            {
                name: "/agent/livelist",
                path: "/agent/livelist",
                component: agent_livelist,
                meta: {title: "直播管理"},
            },
            {
                name: "/agent/livelist/livelog",
                path: "/agent/livelist/livelog",
                component: agent_livelog,
                meta: {title: "发放记录"},
            }
        ]
    },
    {
        path: '/agent/ordermanage',
        name: '/agent/ordermanage',
        component: agent_partner,
        redirect: '/agent/ordermanage',
        children: [
            {
                name: '/agent/ordermanage',
                path: '/agent/ordermanage',
                component: agent_ordermanage,
                meta: {title: '全景直播'}
            },
            {
                name: '/agent/ordermanage/aiDigital',
                path: '/agent/ordermanage/aiDigital',
                component: agent_aiDigital,
                meta: {title: 'AI数字人'}
            },
            {
                name: '/agent/ordermanage/renewalOrder',
                path: '/agent/ordermanage/renewalOrder',
                component: agent_renewalOrder,
                meta: {title: '账户续费'}
            }
        ]
    },
    {
        path: "/agent/data/index",
        name: "/agent/data/index",
        component: agent_partner,
        redirect: "/agent/data",
        children: [
            {
                name: "/agent/data",
                path: "/agent/data",
                component: agent_data,
                meta: {title: "数据信息"},
            },
            {
                name: "/agent/convenientList",
                path: "/agent/convenientList",
                component: convenientList,
                meta: {title: "便民列表"},
            },
            {
                name: "/agent/shopList",
                path: "/agent/shopList",
                component: shopList,
                meta: {title: "商家列表"},
            },
            {
                name: "/agent/typeList",
                path: "/agent/typeList",
                component: typeList,
                meta: {title: "分类列表"},
            },
            {
                name: "/agent/cityList",
                path: "/agent/cityList",
                component: cityList,
                meta: {title: "县城列表"},
            },
        ]
    },
    {
        path: "/agent/means/index",
        name: "/agent/means/index",
        component: agent_partner,
        redirect: "/agent/means",
        children: [
            {
                name: "/agent/means",
                path: "/agent/means",
                component: agent_means,
                meta: {title: "培训资料"},
            },
        ]
    },
    {
        path: "/agent/gxsz/index",
        name: "/agent/gxsz/index",
        component: agent_partner,
        redirect: "/agent/gxsz",
        children: [
            {
                name: "/agent/gxsz",
                path: "/agent/gxsz",
                component: agent_gxsz,
                meta: {title: "基本设置"},
            }, {
                name: "/agent/gxsz/gxgwmb",
                path: "/agent/gxsz/gxgwmb",
                component: agent_gxgwmb,
                meta: {title: "官网模板"},
            }, {
                name: "/agent/gxsz/gxcp",
                path: "/agent/gxsz/gxcp",
                component: gxcp,
                meta: {title: "产品"},
            }, {
                name: "/agent/gxsz/gxtw",
                path: "/agent/gxsz/gxtw",
                component: agent_gxtw,
                meta: {title: "图文"},
            }, {
                name: "/agent/gxsz/gxlb",
                path: "/agent/gxsz/gxlb",
                component: gxlb,
                meta: {title: "列表"},
            }, {
                name: "/agent/gxsz/gxal",
                path: "/agent/gxsz/gxal",
                component: gxal,
                meta: {title: "案例"},
            }, {
                name: "/agent/gxsz/gxlygl",
                path: "/agent/gxsz/gxlygl",
                component: agent_gxlygl,
                meta: {title: "留言管理"},
            }
        ]
    },
    {
        path: "/agent/setup/index",
        name: "/agent/setup/index",
        component: agent_partner,
        children: [
            {
                name: "/agent/setup",
                path: "/agent/setup",
                component: agent_setup,
                meta: {title: "版权设置"},
            },
        ]
    }, {
        path: "/agent/personal/index",
        name: "/agent/personal/index",
        component: agent_partner,
        children: [
            {
                name: "/agent/personal",
                path: "/agent/personal",
                component: agent_personal,
                meta: {title: "个人资料"},
            },
            {
                name: "/agent/password",
                path: "/agent/password",
                component: agent_password,
                meta: {title: "修改密码"},
            },
        ]
    },
    {
        path: "/agent/news/index",
        name: "/agent/news/index",
        component: agent_partner,
        children: [
            {
                name: "/agent/news",
                path: "/agent/news",
                component: agent_news,
                meta: {title: "消息中心"},
            },
            {
                name: "/agent/week",
                path: "/agent/week",
                component: agent_week,
                meta: {title: "系统更新"},
            },
        ]
    },
    {
        path: "/agent/website",
        name: "/agent/website",
        component: agent_website,
        meta: {title: "编辑个性官网"},
    },
    {
        path: "/agent/website1",
        name: "/agent/website1",
        component: agent_website1,
        meta: {title: "编辑个性官网"},
    },
    {
        path: "/agent/web",
        name: "/agent/web",
        component: agent_web,
        meta: {title: "个性官网"},
    },
];

export {
    agent_router
}



// WEBPACK FOOTER //
// ./src/agent/router/index.js